if (!customElements.get('compact-quick-add')) {
  class CompactQuickAdd extends HTMLElement {
    constructor() {
      super();

      this.onToggleClick = this.onToggleClick.bind(this);
    }

    connectedCallback() {
      this.expandBtn = this.querySelector('[data-stl-quickadd]');
      this.popup = this.querySelector('.quick-add__popup-variants');

      this.expandBtn.addEventListener('click', this.onToggleClick);
    }

    disconnectedCallback() {
      this.expandBtn.removeEventListener('click', this.onToggleClick);
    }

    onToggleClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.popup.classList.toggle('compact-quick-add-hidden');
      this.expandBtn.classList.toggle('action-expanded');

      this.expandBtn.setAttribute(
        'aria-expanded',
        String(!this.popup.classList.contains('compact-quick-add-hidden'))
      );
    }
  }

  customElements.define('compact-quick-add', CompactQuickAdd);
}
